import Swal from "sweetalert2";

/**
 * @param {object} errors
 */
const showValidationErrors = (errors) => {
  var messageUl = document.createElement("ul");
  Object.keys(errors).forEach((fields) => {
    var messageLi = document.createElement("li");
    var messageText = document.createTextNode(errors[fields][0]);
    messageLi.appendChild(messageText);
    messageUl.appendChild(messageLi);
  });

  Swal.fire({
    icon: 'warning',
    title: "",
    html: messageUl.outerHTML,
  });
};

export default showValidationErrors;
